import React from 'react';
import { connect } from 'react-redux';
import * as R from 'ramda';
import {
  Badge,
  Checkbox,
  Select,
  Input,
  Avatar,
  Form,
  Card,
  Modal,
  Divider,
  Button,
  Row,
  Col,
  Icon,
  Dropdown,
  Menu,
  Breadcrumb,
  List,
  Tag,
  Layout,
  Switch
} from 'antd';
import { undoEditCategory, editCategory } from '../../common/reducers/categoryReducer';
import VBQLArea from '../Query/VBQLArea';

class CategoryCard extends React.Component {
  static getDerivedStateFromProps(props, state) {
    if (!props.enableEdit && state.mode === 'edit') {
      return { mode: 'view' };
    }
    return null;
  }
  state = {
    mode: 'view',
  };
  handleEdit = () => {
    this.setState({ mode: 'edit' });
  };
  handleCancel = () => {
    this.setState({ mode: 'view' });
  };
  handleDone = () => {
    const { form, onEdit } = this.props;
    form.validateFields((err, values) => {
      if (!err) {
        onEdit({ ...values });
        this.setState({ mode: 'view' });
      }
    });
  };
  * renderProps() {
    const { form, category, revisions, keys } = this.props;
    const { mode } = this.state;

    const isEditing = mode === 'edit';
    const keySet = new Set(keys);

    const renderBadge = (prop) => {
      if (Object.prototype.hasOwnProperty.call(revisions, prop)) return (<span> <Badge status="success" /></span>);
    };

    if (keySet.has('published')) {
      if (isEditing) {
        yield (
          <Form.Item
            label="Published?"
            key="published"
          >
            {form.getFieldDecorator('published', {
              initialValue: category.published,
            })(
              <Switch defaultChecked={category.published} />
            )}
            <span style={{ marginLeft: '10px' }}>{!form.getFieldValue('published') && 'Not '}Published</span>
          </Form.Item>
        );
      } else {
        yield (
          <List.Item
            key="published"
          >
            <List.Item.Meta
              title={<span>Published{renderBadge('published')}</span>}
              description={category.published}
            />
          </List.Item>
        );
      }
    }

    if (keySet.has('description')) {
      if (isEditing) {
        yield (
          <Form.Item
            label="Description"
            key="description"
          >
            {form.getFieldDecorator('description', {
              initialValue: category.description,
              rules: [{
                required: true, message: 'You must enter a description',
              }],
            })(
              <Input />,
            )}
          </Form.Item>
        );
      } else {
        yield (
          <List.Item
            key="description"
          >
            <List.Item.Meta
              title={<span>Description{renderBadge('description')}</span>}
              description={category.description}
            />
          </List.Item>
        );
      }
    }

    if (keySet.has('tags')) {
      if (isEditing) {
        yield (
          <Form.Item
            key="tags"
            label="Labels"
          >
            {form.getFieldDecorator('tags', {
              initialValue: category.tags,
            })(
              <Select
                mode="tags"
                notFoundContent="No labels entered"
                style={{ width: '100%' }}
                tokenSeparators={[',']}
              />,
            )}
          </Form.Item>
        );
      } else {
        yield (
          <List.Item
            key="tags"
          >
            <List.Item.Meta
              title={<span>Labels{renderBadge('tags')}</span>}
              description={<span>{category.tags.map((tag, i) => <Tag key={i}>{tag}</Tag>)}</span>}
            />
          </List.Item>
        );
      }
    }

    if (keySet.has('created')) {
      if (isEditing) {
        yield (
          <Form.Item
            key="created"
            label="Created"
          >
            {category.created}
          </Form.Item>
        );
      } else {
        yield (
          <List.Item
            key="created"
          >
            <List.Item.Meta
              title="Created"
              description={category.created}
            />
          </List.Item>
        );
      }
    }

    if (keySet.has('notes')) {
      if (isEditing) {
        yield (
          <Form.Item
            label="Notes"
            key="notes"
          >
            {form.getFieldDecorator('notes', {
              initialValue: category.notes,
            })(
              <Input.TextArea/>,
            )}
          </Form.Item>
        );
      } else {
        yield (
          <List.Item
            key="notes"
          >
            <List.Item.Meta
              title={<span>Notes{renderBadge('notes')}</span>}
              description={category.notes}
            />
          </List.Item>
        );
      }
    }

    if (keySet.has('version')) {
      if (isEditing) {
        yield (
          <Form.Item
            key="version"
            label="Version"
          >
            {form.getFieldDecorator('version', {
              initialValue: category.version,
            })(
              <Input />,
            )}
          </Form.Item>
        );
      } else {
        yield (
          <List.Item
            key="version"
          >
            <List.Item.Meta
              title={<span>Version{renderBadge('version')}</span>}
              description={
                category.version && <Tag color="blue">{category.version}</Tag>
              }
            />
          </List.Item>
        );
      }
    }

    if (keySet.has('query')) {
      if (isEditing) {
        yield (
          <Form.Item
            label="Definition"
            key="definition"
          >
            {form.getFieldDecorator('query', {
              initialValue: category.query,
              rules: [{
                required: true, message: 'You must enter a query definition',
              }],
            })(
              <VBQLArea />,
            )}
          </Form.Item>
        );
      } else {
        yield (
          <List.Item
            key="definition"
          >
            <List.Item.Meta
              title={<span>Definition{renderBadge('query')}</span>}
              description={<VBQLArea readonly value={category.query} />}
            />
          </List.Item>
        );
      }
    }

    if (isEditing) {
      yield (
        <Form.Item key="__controls" style={{ marginBottom: '0' }}>
          <Row type="flex" justify="end" gutter={16}>
            <Col><Button onClick={this.handleCancel}>Cancel</Button></Col>
            <Col><Button onClick={this.handleDone} type="primary">Apply</Button></Col>
          </Row>
        </Form.Item>
      );
    }
  }
  render() {
    const { enableEdit, loading, category, title, icon } = this.props;
    const { mode } = this.state;

    return (
      <Card
        bordered={false}
        loading={loading}
        title={
          <div>
            <span style={{ marginRight: '16px' }}><Avatar icon={icon} /></span>
            {title}
          </div>
        }
        extra={enableEdit && mode === 'view' &&
          <Button
            icon="edit"
            shape="circle"
            style={{ border: 'none' }}
            onClick={this.handleEdit}
          />
        }
      >
        {!loading && (
          mode === 'edit'
            ? <Form onSubmit={this.handleSubmit}>
              {[...this.renderProps()]}
            </Form>
            : <List
              bordered={false}
              split={false}
            >
              {[...this.renderProps()]}
            </List>
        )}
      </Card>
    );
  }
}

export default Form.create()(CategoryCard);
